/**
 * التحقق من هوية العميل قبل إرسال/إكمال OTP في صفحات الدفع.
 * يمنع إنشاء حساب ببريد وهمي (@placeholder.auth) دون إدخال بيانات حقيقية.
 */

export function isValidCheckoutCustomerName(name) {
  return typeof name === 'string' && name.trim().length >= 2;
}

export function isValidCheckoutCustomerEmail(email) {
  const t = (email || '').trim().toLowerCase();
  if (!t) return false;
  if (t.endsWith('@placeholder.auth')) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t);
}

/** رسائل عربية جاهزة للـ toast */
export function validateCheckoutIdentityBeforeOtp(formData) {
  if (!isValidCheckoutCustomerName(formData?.fullName)) {
    return {
      ok: false,
      message: 'يرجى إدخال الاسم الكامل (حرفان على الأقل) قبل إرسال رمز التحقق',
    };
  }
  if (!isValidCheckoutCustomerEmail(formData?.email)) {
    return {
      ok: false,
      message: 'يرجى إدخال بريد إلكتروني صالح قبل إرسال رمز التحقق',
    };
  }
  return { ok: true };
}
